import * as React from 'react';
import { AutomataContext, AutomataEvent, AutomataService, States } from '../../../../../../Machines/organisations/search';
import { State } from 'xstate';
import InputError from './Error';
import Input from './Input';
import Loading from './Loading';

type Props = {
  service: AutomataService;
  current: State<AutomataContext, AutomataEvent>;
};
export default ({ service, current }: Props) => (
  <div className="flex justify-center">
    {current.matches(States.SEARCH_ORGANISATIONS_SCREEN) && <Input service={service} current={current} />}

    {current.matches(States.SEARCH_ORGANISATIONS_REQUEST) && <Loading service={service} current={current} />}

    {current.matches(States.SEARCH_ORGANISATIONS_ERROR) && <InputError service={service} current={current} />}
  </div>
);
